module.exports = __webpack_public_path__ + "static/media/DSC_8451.670dd966.jpg";